/**
 * Perf-only invalidate pump — keeps R3F demand/always roots rendering while
 * commit sampling is active. Zero work when sampling is off.
 */
import { isPerfCommitSamplingActive } from "./perf-frame-sampler.js";

const invalidateStack: Array<() => void> = [];
let pumpRaf = 0;

/** Push on mount, pass null on unmount to pop. */
export function registerPerfInvalidate(fn: (() => void) | null): void {
  if (fn) {
    invalidateStack.push(fn);
    return;
  }
  invalidateStack.pop();
}

export function getPerfInvalidateDepth(): number {
  return invalidateStack.length;
}

export function stopPerfInvalidatePump(): void {
  if (pumpRaf) {
    cancelAnimationFrame(pumpRaf);
    pumpRaf = 0;
  }
}

/** Start (or restart) a rAF pump that invalidates registered reel roots while sampling. */
export function startPerfInvalidatePump(): void {
  stopPerfInvalidatePump();
  if (typeof requestAnimationFrame === "undefined") return;
  const tick = () => {
    if (!isPerfCommitSamplingActive()) {
      pumpRaf = 0;
      return;
    }
    for (const fn of invalidateStack) {
      try {
        fn();
      } catch {
        /* ignore stale roots */
      }
    }
    pumpRaf = requestAnimationFrame(tick);
  };
  pumpRaf = requestAnimationFrame(tick);
}
